(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/views/tipsen/tipset.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/views/tipsen/tipset.js');

'use strict';

const SportinfoPathNames = svs.components.sportinfo.common.constants.SportinfoPathNames;
svs.game_results.views.Tipset = Marionette.View.extend({
  template(data) {
    return svs.game_results.templates.tipset(data);
  },
  className: 'game-results',
  regions: {
    bigStatRegion: '#bigStatRegion',
    gameResultsLive: '#game-results-live',
    forecastPayment: '#forecast-payment'
  },
  events: {
    'click .js-expand-big-statistics': 'expandBigStatistics'
  },
  modelEvents: {
    'change:result': 'render',
    'change:regCloseTime': 'render',
    'change:drawState': 'drawStateUpdated',
    'change:forecast': 'forecastChanged',
    'change:resultIdx': 'resultIdUpdated',
    'change:liveResults': 'liveResultsUpdated'
  },
  initialize() {
    this.bigStat = new svs.game_results.BigStat();
  },
  getBigStatOptions(e) {
    const cleanedUpPathname = Backbone.history.location.pathname.replace(new RegExp("/".concat(Object.values(SportinfoPathNames).join('|'), "$"), 'i'), '');
    const pathname = cleanedUpPathname;
    const matchId = e && parseInt(e.currentTarget.id.split('-')[1], 10);
    const drawNumber = this.model.get('result') ? this.model.get('result')[0].drawNumber : this.model.get('liveResults').drawNumber;
    const bigStatOptions = {
      productId: this.model.get('result') ? this.model.get('result')[0].productId : this.model.get('liveResults').productId,
      drawNumber,
      matchId,
      queryKey: 'match',
      searchParams: "match=".concat(matchId),
      tab: svs.game_results.data.params.tab,
      domElement: svs.core.detect.formfactor.desktop() ? '#bigStatRegion' : '#bigstat-modal',
      modulePath: pathname
    };
    return bigStatOptions;
  },
  onRender() {
    let calenderDate;
    let capitalizedDay;
    const self = this;
    this.handleExtratipset();
    if (this.model.get('liveResults')) {
      const liveResults = this.model.get('liveResults').drawEvents;
      this.matchList = new svs.game_results.collections.MatchList(liveResults, {
        modelFromView: this.model
      });
      this.showChildView('gameResultsLive', new svs.game_results.views.MatchList({
        collection: this.matchList
      }));
    }
    if (this.model.get('forecast') && !this.model.get('isBeforeStart')) {
      this.forecastPayment = new svs.game_results.models.ForecastPayment({
        forecast: this.model.get('forecast'),
        product: this.model.get('product')
      });
      this.showChildView('forecastPayment', new svs.game_results.views.ForecastPayment({
        model: this.forecastPayment
      }));
    }
    if (!svs.core.detect.formfactor.mobile()) {
      self.setUpDimensions();
      svs.core.detect.orientation.on('change', () => {
        self.setUpDimensions();
      });
      $('body').addClass('game-result-wrap');
    }
    if (this.model.get('regCloseTime')) {
      calenderDate = dateFns.format(new Date(this.model.get('regCloseTime')), "EEEE d MMMM ' (v. 'w')'", {
        locale: dateFns.locales.sv
      });
      capitalizedDay = calenderDate.charAt(0).toUpperCase() + calenderDate.substring(1);
      $('.js-calendar-title').text(capitalizedDay);
    }
    if (this.model.get('result')) {
      setTimeout(() => {
        const bigStatOptions = this.getBigStatOptions();
        this.bigStat.navToBigStat(bigStatOptions);
      }, 200);
    }
    svs.game_results.models.calendar.on('change:date', () => {
      const domElement = svs.core.detect.formfactor.desktop() ? '#bigStatRegion' : '#bigstat-modal';
      this.bigStat.closeBigStat(domElement);
      svs.game_results.data.params.tab = undefined;
    });

    _.defer(() => {
      $('html, body').animate({
        scrollTop: 0
      }, 'fast');
    });
    $('.game-results-calendar').css('width', $('#gameResult').width());
  },
  forecastChanged() {
    const forecast = this.model.get('forecast');
    if (forecast && this.forecastPayment) {
      this.forecastPayment.set('forecast', forecast);
      this.forecastPayment.set('winresult', forecast.winresult);
      this.forecastPayment.set('multiForecast', forecast.multiForecast);
    }
  },
  liveResultsUpdated() {
    this.matchList.updateMatches(this.model.get('liveResults').drawEvents);
  },
  drawStateUpdated() {
    const forecast = this.model.get('forecast');
    const drawState = forecast ? forecast.drawState : '';
    if (drawState && drawState == svs.game_results.constants.drawStates.FINALIZED) {
      this.model.set('roundIsLive', false, {
        silent: true
      });
    }
    this.render();
  },
  resultIdUpdated() {
    const changes = this.options.model.get('changes');
    const forecast = this.options.model.get('forecast');
    let matchIndex = 0;
    for (let i = 0; i < changes.length; i++) {
      matchIndex = changes[i].evnum - 1;
      this.matchList.models[matchIndex].set('forecastResult', forecast.drawResults[matchIndex]);
      this.matchList.models[matchIndex].set('latestUpdate', changes[i].team, {
        silent: true
      });
      this.matchList.models[matchIndex].updateStatuses();
      this.matchList.models[matchIndex].trigger('matchUpdated', this.matchList.models[matchIndex]);
    }
  },
  handleExtratipset() {
    var _svs$game_results$dat, _this$model$get$, _this$model$get$2;
    const extratipsetName = (_svs$game_results$dat = svs.game_results.data.cms) === null || _svs$game_results$dat === void 0 ? void 0 : _svs$game_results$dat.extratipset.productName;
    if (svs.game_results.data.isExtratipset && this.model.get('liveResults') && this.model.get('liveResults').userProduct === 'EmTipset' && this.model.get('product') === 'europatipset') {
      svs.core.template.updateConfig({
        title: {
          row1: {
            brand: 'em-tipset',
            alt: 'EM-Tipset'
          }
        }
      });
      $('#top-content').removeClass('header-europatipset').addClass('header-extratipset');
      $('.js-game-results-calendar').removeClass('calendar-europatipset').addClass('calendar-extratipset');
      this.model.set('product', 'extratipset', {
        silent: true
      });
      this.render();
    } else if (svs.game_results.data.isExtratipset && this.model.get('result') && ((_this$model$get$ = this.model.get('result')[0]) === null || _this$model$get$ === void 0 ? void 0 : _this$model$get$.productName) === extratipsetName && this.model.get('product') === 'europatipset') {
      let headerIcon = '';
      let iconAlt = '';
      if (extratipsetName === 'EmTipset') {
        headerIcon = 'em-tipset';
        iconAlt = 'EM-Tipset';
      } else if (extratipsetName === 'VmTipset') {
        headerIcon = 'vm-tipset';
        iconAlt = 'VM-Tipset';
      } else {
        headerIcon = 'extratipset';
        iconAlt = 'Extratipset';
      }
      svs.core.template.updateConfig({
        title: {
          row1: {
            brand: headerIcon,
            alt: iconAlt
          }
        }
      });
      $('#top-content').removeClass('header-europatipset').addClass('header-extratipset');
      $('.js-game-results-calendar').removeClass('calendar-europatipset').addClass('calendar-extratipset');
      this.model.set('product', 'extratipset', {
        silent: true
      });
      this.render();
    } else if (this.model.get('result') && ((_this$model$get$2 = this.model.get('result')[0]) === null || _this$model$get$2 === void 0 ? void 0 : _this$model$get$2.productName) === 'Europatipset' && $('#top-content').hasClass('header-extratipset')) {
      svs.core.template.updateConfig({
        title: {
          row1: {
            brand: 'europatipset',
            alt: 'Europatipset'
          }
        }
      });
      $('#top-content').removeClass('header-extratipset').addClass('header-europatipset');
      $('.js-game-results-calendar').removeClass('calendar-extratipset').addClass('calendar-europatipset');
      this.model.set('product', 'europatipset', {
        silent: true
      });
      this.render();
    }
  },
  setUpDimensions() {
    const $bigStatRegion = $('#bigStatRegion');
    const availableHeight = svs.game_results.utils.calcAvailableHeight();
    $bigStatRegion.css('height', availableHeight);
    $bigStatRegion.removeClass('europatipset-background extratipset-background');
    $bigStatRegion.addClass("".concat(this.model.get('product'), "-background"));
    $('#coupon').css({
      height: "".concat(availableHeight - 12, "px"),
      'overflow-y': 'auto',
      '-webkit-overflow-scrolling': 'touch'
    });
  },
  expandBigStatistics(e) {
    const bigStatOptions = this.getBigStatOptions(e);
    this.bigStat.openBigStat(bigStatOptions);
    this.bigStat.updateBigStatUrlQuery(bigStatOptions);
  }
});

 })(window);